import { useMemo } from 'react';
import { useQuery } from 'shared-ui';

import { QueryKeyEnum } from 'core/global.enum';
import { fetchMailAccount } from 'api/mailAccount/mailAccount';

export const useSmtpConfiguration = () => {
  const { data: mailAccountResponse, isLoading } = useQuery([QueryKeyEnum.MAIL_ACCOUNT], fetchMailAccount);

  const isSmtpConfigured = useMemo(() => {
    return !!mailAccountResponse?.address;
  }, [mailAccountResponse]);

  return {
    isSmtpConfigured,
    isLoading,
    mailAccountResponse,
  };
};
